import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
import * as AOS from 'aos';


@Component({
  selector: 'app-homenew',
  templateUrl: './homenew.component.html',
  styleUrls: ['./homenew.component.scss']
})
export class HomenewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    // Animation framework
    AOS.init({
      
    });


  }

}
